<template>
  <b-server-table
    :key="tableRenderKey"
    :filter-props="{
      filterMap: [{ key: 'search' }],
    }"
    :headers="registrationJournalListHeaders"
    :request-func="registrationJournalList"
    @click:row="
      $router.push({
        name: 'registration-journal-single',
        params: { id: $event.id },
      })
    ">
    <template #bottom></template>
    <template #action-button>
      <v-btn @click="openCreateDialog">
        <v-icon class="mr-1">mdi-plus</v-icon>
        Створити журнал
      </v-btn>
    </template>
    <template #item.name="{ item }">
      <span class="font-weight-bold">{{ item.name }}</span>
    </template>
    <template #item.code="{ item }">
      <v-chip color="grey" density="compact" rounded="lg" size="small">
        <span class="font-weight-bold text-grey-darken-2">
          {{ item.code }}
        </span>
      </v-chip>
    </template>
    <template #item.isActive="{ item }">
      <v-chip :color="item.isActive ? 'success' : 'error'" size="small">
        {{ item.isActive ? 'Активний' : 'Неактивний' }}
      </v-chip>
    </template>
    <template #item.numberMask="{ item }">
      <span>{{ item.numberMask || '—' }}</span>
    </template>
    <template #item.actions="{ item }">
      <b-action-menu
        :actions="[
          {
            title: 'Відкрити',
            action: () =>
              router.push({
                name: 'registration-journal-single',
                params: { id: item.id },
              }),
            icon: 'mdi-eye',
            iconProps: {
              color: 'blue-darken-3',
            },
          },
          {
            title: item.isActive ? 'Деактивувати' : 'Активувати',
            action: () => toggleActive(item),
            listItemProps: {
              class: 'text-error',
            },
            icon: item.isActive ? 'mdi-close-circle' : 'mdi-check-circle',
            iconProps: {
              color: 'error',
            },
          },
          {
            title: 'Видалити',
            action: () => deleteJournal(item),
            icon: 'mdi-delete',
            color: 'error',
            listItemProps: {
              class: 'text-error',
            },
          },
        ]">
      </b-action-menu>
    </template>
  </b-server-table>
</template>
<script>
import { ref } from 'vue'
import { BActionMenu, BServerTable } from 'best-modules/components/index'
import { useRouter } from 'vue-router'
import {
  registrationJournalActivate,
  registrationJournalDeactivate,
  registrationJournalDelete,
  registrationJournalList,
} from '@/requests/registrationJournal'
import { registrationJournalListHeaders } from '@/utils/tableHeaders'
import { openDialog } from '@/dialog'

export default {
  name: 'RegistrationJournalList',
  components: { BActionMenu, BServerTable },
  data() {
    return {
      registrationJournalListHeaders,
    }
  },
  methods: { registrationJournalList },
  setup() {
    const router = useRouter()
    const tableRenderKey = ref(1)

    const openCreateDialog = () => {
      openDialog({
        name: 'RegistrationJournal',
        action: 'create',
        params: {
          title: 'Створити журнал реєстрації',
          submitLabel: 'Створити',
          cb: res => {
            router.push({
              name: 'registration-journal-single',
              params: { id: res.id },
            })
          },
        },
      })
    }

    const toggleActive = item => {
      const url = item.isActive
        ? registrationJournalDeactivate
        : registrationJournalActivate
      return url(item.id).then(() => {
        tableRenderKey.value += 1
      })
    }

    const deleteJournal = item => {
      return registrationJournalDelete(item.id).then(() => {
        tableRenderKey.value += 1
      })
    }

    return {
      router,
      toggleActive,
      deleteJournal,
      tableRenderKey,
      openCreateDialog,
    }
  },
}
</script>
